module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/xpelv1-a809f847ba652af4460d50e39460ce64.jpg";